import * as motion from "motion/react-client";
import { Box, Container, Typography } from "@mui/material";

import useScrollHandler from "../../../Components/Hooks/useScrollHandler";
import img from "../../../Images/Main-Header_011723.jpg";

function Header() {
  const scroll = useScrollHandler(
    {
      scrollCalc: 0,
      scroll: 0,
      active: false,
    },
    "ScrollShow",
    10
  );

  return (
    <Box className="relative h-screen" id="ScrollShow">
      <motion.img
        className="absolute top-0 left-0 right-0 bottom-0 w-screen h-screen object-cover -z-10"
        src={img}
        alt=""
        animate={{
          y: scroll.scrollCalc / 2,
        }}
        transition={{
          type: "tween",
          damping: 5,
          stiffness: 5,
          duration: 0.07,
        }}
      />
      <Container
        sx={{ maxWidth: { lg: "1024px", xl: "1280px", xxl: "1536px" } }}
        maxWidth="xl"
        className="flex flex-col justify-center items-center gap-6 h-full"
        initial="offscreen"
        whileInView="onscreen"
        component={motion.div}
        variants={{
          offscreen: {
            opacity: 0,
          },
          onscreen: {
            opacity: 1,
          },
        }}
        viewport={{ amount: 0.8 }}
      >
        <Typography
          variant="h2"
          component="h1"
          color="#fff"
          fontSize={{ xs: 30, lg: 40, xl: 50, xxl: 55 }}
          fontWeight={900}
          textTransform="uppercase"
        >
          MEET FUTURE AT HOME
        </Typography>
        <Typography
          width={{ xs: "100%", sm: "600px", lg: "80%", xl: 1000 }}
          color="#fff"
          textAlign="center"
          fontSize={{ xs: 18, lg: 24, xl: 29, xxl: 30 }}
          letterSpacing={1}
          fontWeight={300}
          lineHeight={1.2}
        >
          We connect smart devices to work in unison, delivering a truly
          intelligent smart home experience that makes life more convenient,
          safe, and enjoyable.
        </Typography>
        {/* <Button
          variant="outlined"
          size="large"
          color="white"
          sx={{
            fontSize: { xs: 14, lg: 16, xxl: 18 },
            borderColor: "#fff",
            py: { xs: 1, lg: 1.5, xl: 2 },
            "&:hover": {
              backgroundColor: "primary.dark",
              borderColor: "primary.dark",
            },
          }}
        >
          Check It Out
        </Button> */}
      </Container>
    </Box>
  );
}

export default Header;
